import slugify from 'slugify';


export default {
  getStandardLevels(context) {
    context.commit('setStandardLevels');
    context.commit('setStandardLevelsData')
  },
  setSoundSequenceNames(context) {
    context.commit('setSoundSequenceNames');
  },
  setCurrentlySelectedLevel(context, payload) {
    context.commit('setCurrentlySelectedLevel', payload);
    //context.commit('setCurrentlySelectedLevelIndex', payload);
  },
  setCurrentlySelectedStandardLevelData(context, payload) {
    context.commit('setCurrentlySelectedStandardLevelData', payload);
  },
  initializeSelectedLevels(context) {
    context.commit('initializeSelectedLevels');
  },
  setShowLevels(context, payload) {
    context.commit('setShowLevels', payload);
  },
  addUserExercise(context, payload) {
    context.commit('addUserExercise', payload);
  },
  replaceUserExercise(context, payload) {
    context.commit('replaceUserExercise', payload);
  },
  deleteExercise(context, payload) {
    context.commit('deleteExercise', {exerciseToDeleteID: payload, exerciseListToDeleteFrom: context.state.currentUserDiscipline});
  },
  setCurrentRouteName(context, payload) {
    context.commit('setCurrentRouteName', payload);
  },
  setCurrentRoutePath(context, payload) {
    context.commit('setCurrentRoutePath', payload);
  },
  setCurrentlySelectedUserDiscipline(context) {
    const table = {
      IdentifyChords: 'userLevelsIdentifyChords',
      createIdentifyChordsExercise: 'userLevelsIdentifyChords',
      editIdentifyChordsExercise: 'userLevelsIdentifyChords',
      IdentifyIntervals: 'userLevelsIdentifyIntervals',
      createIdentifyIntervalsExercise: 'userLevelsIdentifyIntervals',
      editIdentifyIntervalsExercise: 'userLevelsIdentifyIntervals',
      CompareIntervalSizes: 'userLevelsCompareIntervalSizes',
      createCompareIntervalSizesExercise: 'userLevelsCompareIntervalSizes',
      editCompareIntervalSizesExercise: 'userLevelsCompareIntervalSizes',
      IdentifyChordInversions: 'userLevelsIdentifyChordInversions',
      createIdentifyChordInversionsExercise: 'userLevelsIdentifyChordInversions',
      editIdentifyChordInversionsExercise: 'userLevelsIdentifyChordInversions',
      IdentifyScales: 'userLevelsIdentifyScales',
      createIdentifyScalesExercise: 'userLevelsIdentifyScales',
      editIdentifyScalesExercise: 'userLevelsIdentifyScales'
    };
    let currentlySelectedUserDiscipline = table[context.state.currentRouteName];
    context.commit('setCurrentUserDiscipline', currentlySelectedUserDiscipline);
  },
  setIsExerciseBeingEdited(context, payload) {
    context.commit('setIsExerciseBeingEdited', payload);
  },
  setExerciseBeingEdited(context, payload) {
    context.commit('setExerciseBeingEdited', payload);
  },
  setCorrectNotes(context, payload) {
    context.commit('setCorrectNotes', payload);
  },
  setIncorrectNotes(context, payload) {
    context.commit('setIncorrectNotes', payload);
  },
  setCorrectNotesPositionX(context, payload) {
    context.commit('setCorrectNotesPositionX', payload);
  },
  setIncorrectNotesPositionX(context, payload) {
    context.commit('setIncorrectNotesPositionX', payload);
  },
  addAnswerToprogressLamps(context, payload) {
    context.commit('addAnswerToprogressLamps', payload);
  },
  resetprogressLamps(context) {
    context.commit('resetprogressLamps');
  },
  setIsGameRunning(context, payload) {
    context.commit('setIsGameRunning', payload);
  },
  setExercisePlayingBasedOnRoute(context) {

    let disciplineName;
    let exerciseType = context.state.showLevels; // Standard or User
    let exerciseName;
    let exerciseIndex;
    let exercisePlaying = {};
    
    let path = context.state.currentRoutePath;
    let splitPath = path.split('/');
    
    splitPath.shift(); // Remove first entry in array because it's empty
    disciplineName = splitPath[0];
    
    disciplineName = disciplineName.split('-'); 

    disciplineName.forEach((item, index) => {
      // Capitalize first character of ecery word in array so we can use it to fint the correct entry in the store
      disciplineName[index] = item.charAt(0).toUpperCase() + item.slice(1);
    });

    // Put together the capitalized words, so we have the final name of the entry in the store
    disciplineName = disciplineName.join('');

    let arrayOfExercises;
    let staticStandardDisciplineName = 'standardLevels' + disciplineName;

    // if standard exercise
    if (exerciseType === 'standard') {
      exerciseName = splitPath[2];
      disciplineName = 'standardLevels' + disciplineName;
      
      // Find object in the correct array of exercises
      arrayOfExercises = context.state[disciplineName];


      for (let i = 0; i < arrayOfExercises.length; i++) {
        if (slugify(arrayOfExercises[i]['title'], {
          replacement: '-',
          remove: /[*/+~.()'",!:@]/g,
          lower: true
        }).replace(/#/g, '-sharp-') === exerciseName) {
          exerciseIndex = i;
          exercisePlaying = {
            exerciseInfo: arrayOfExercises[i],
            exerciseData: context.state[`${disciplineName}Data`][i]
          }
        }
      }

    } else if (exerciseType === 'user') {
      exerciseName = splitPath[3];
      disciplineName = 'userLevels' + disciplineName;
      // Find object in the correct array of exercises
      arrayOfExercises = context.state[disciplineName];

      for (let i = 0; i < arrayOfExercises.length; i++) {
        if (slugify(arrayOfExercises[i]['title'], {
          replacement: '-',
          remove: /[*/+~.()'",!:@]/g,
          lower: true
        }).replace(/#/g, '-sharp-') === exerciseName) {
          exerciseIndex = i;
          exercisePlaying = {
            exerciseInfo: {
              id: arrayOfExercises[i].id,
              title: arrayOfExercises[i].title,
              shortDescription: '',
              description: arrayOfExercises[i].description
            },
            exerciseData: {
              id: arrayOfExercises[i].id,
              soundSequences: arrayOfExercises[i].soundSequences,
              harmony: arrayOfExercises[i].harmony,
              randomRoot: arrayOfExercises[i].randomRoot,
              numberOfQuestions: 20
            }
          }
        }
      }
    }

    
    context.commit('setExercisePlaying', exercisePlaying);
    
    //context.commit('setDisciplinePlaying', disciplineName); // THIS IS IT.. set tu user instead of standard
    context.commit('setDisciplinePlaying', staticStandardDisciplineName);
    context.commit('setCurrentExerciseIndex', exerciseIndex);
  },
  setExercisePlaying(context, payload) {
    context.commit('setExercisePlaying', payload);
  },
  setDisciplinePlaying(context, payload) {
    context.commit('setDisciplinePlaying', payload);
  },
  setcurrentExerciseRandomQuestions(context, payload) {
    context.commit('setcurrentExerciseRandomQuestions', payload);
  },
  setquestionNumberInCurrentExercise(context, payload) {
    context.commit('setquestionNumberInCurrentExercise', payload);
  },
  setCorrectAnswer(context, payload) {
    context.commit('setCorrectAnswer', payload);
  },
  setUserAnswer(context, payload) {
    context.commit('setUserAnswer', payload);
  },
  setSoundsequenceDataForCorrectAnswer(context, payload) {
    context.commit('setSoundsequenceDataForCorrectAnswer', payload);
  },
  setQuestionStartNote(context, payload) {
    context.commit('setQuestionStartNote', payload);
  },
  setDisciplineModeTonal(context, payload) {
    context.commit('setDisciplineModeTonal', payload);
  },
  setWaitingForUserAnswer(context, payload) {
    context.commit('setWaitingForUserAnswer', payload);
  },
  setShowEvaluationPopup(context, payload) {
    context.commit('setShowEvaluationPopup', payload);
  },
  setCurrentExerciseScore(context, payload) {

    let scorePercentage = (payload.correctAnswers / (payload.questionNumber + 1)) * 100;

    context.commit('setCurrentExerciseScore', scorePercentage);
  },
  resetCurrentExerciseScore(context) {
    context.commit('resetCurrentExerciseScore', 0);
  },
  resetProgressLamps(context) {
    context.commit('resetProgressLamps', []);
  },
  setCorrectAnswersInCurrentExercise(context, payload) {
    context.commit('setCorrectAnswersInCurrentExercise', payload);
  },
  setNextQuestionText(context, payload) {
    context.commit('setNextQuestionText', payload);
  },
  setCorrectOrWrongAnswer(context, payload) {
    context.commit('setCorrectOrWrongAnswer', payload);
  },
  setCompareIntervalSizesCorrectData(context, payload) {
    context.commit('setCompareIntervalSizesCorrectData', payload);
  },
  setCompareIntervalSizesIncorrectData(context, payload) {
    context.commit('setCompareIntervalSizesIncorrectData', payload);
  },
  setAnswersForPossibleIdentifyChordInversions(context, payload) {
    context.commit('setAnswersForPossibleIdentifyChordInversions', payload);
  },
  setAllAnswerPossibilitiesForChordInversions(context, payload) {
    context.commit('setAllAnswerPossibilitiesForChordInversions', payload);
  },
  setStartnoteBeforeInvert(context, payload) {
    context.commit('setStartnoteBeforeInvert', payload);
  },
  setSoundSequenceForIntervalAandIntervalB(context, payload) {
    context.commit('setSoundSequenceForIntervalAandIntervalB', payload);
  },
  setStandardScore(context, payload) {
    context.commit('setStandardScore', payload);
  },
  setAllStandardExerciseScores(context, payload) {
    context.commit('setAllStandardExerciseScores', payload);
  },
  setAllUserExercises(context, payload) {
    context.commit('setAllUserExercises', payload);
  },
  setUserScore(context, payload) {
    context.commit('setUserScore', payload);
  },
  setTimeIntervalBetweenNotes(context, payload) {
    context.commit('setTimeIntervalBetweenNotes', payload);
  },
  setAutoContinue(context, payload) {
    context.commit('setAutoContinue', payload);
  },
  setVolume(context, payload) {
    context.commit('setVolume', payload);
  },
  setPlayableKeyboard(context, payload) {
    context.commit('setPlayableKeyboard', payload);
  },
  setPlayScaleOctave(context, payload) {
    context.commit('setPlayScaleOctave', payload);
  },
  setAnswerSound(context, payload) {
    context.commit('setAnswerSound', payload);
  },
  setShowExerciseDescription(context, payload) {
    context.commit('setShowExerciseDescription', payload);
  },
  setShowExerciseList(context, payload) {
    context.commit('setShowExerciseList', payload);
  },
  setShowCreateExerciseSoundSequenceList(context, payload) {
    context.commit('setShowCreateExerciseSoundSequenceList', payload);
  },
  setShowCreateExerciseSettings(context, payload) {
    context.commit('setShowCreateExerciseSettings', payload);
  },
  setShowUserExerciseDescription(context, payload) {
    context.commit('setShowUserExerciseDescription', payload);
  },
  setShowUserExerciseList(context, payload) {
    context.commit('setShowUserExerciseList', payload);
  },
  // User login stuff

  setUser(context, payload) {
    context.commit('setUser', payload);
  },
  setAccessToken(context, payload) {
    context.commit('setAccessToken', payload);
  },
  setShowSignUpDialog(context, payload) {
    context.commit('setShowSignUpDialog', payload);
  },
  setShowLogInDialog(context, payload) {
    context.commit('setShowLogInDialog', payload);
  },
  setShowUserMenu(context, payload) {
    context.commit('setShowUserMenu', payload);
  },
  setShowUserMenuDialogMobile(context, payload) {
    context.commit('setShowUserMenuDialogMobile', payload);
  },
  setShowLoginSignupBottomSheet(context, payload) {
    context.commit('setShowLoginSignupBottomSheet', payload);
  },
  setShowLoginToAccessDialog(context, payload) {
    context.commit('setShowLoginToAccessDialog', payload);
  },
  setUserObject(context, payload) {
    context.commit('setUserObject', payload);
  },
  setShowDataCopiedToDatabaseDialog(context, payload) {
    context.commit('setShowDataCopiedToDatabaseDialog', payload);
  },
  setSnackbar(context, snackbar) {
    snackbar.showing = true;
    context.commit('setSnackbar', snackbar);
  },
  setAlertDialog(context, alertDialog) {
    alertDialog.showing = true;
    context.commit('setAlertDialog', alertDialog);
  },
  resetUserScores(context, payload) {
    context.commit('resetUserScores', payload);
  },
  resetStandardScores(context, payload) {
    context.commit('resetStandardScores', payload);
  },
  deleteUserExercises(context) {
    context.commit('deleteUserExercises');
  },
  setNavigatedFromStartButton(context, payload) {
    context.commit('setNavigatedFromStartButton', payload);
  }

}